import { Divider } from "@mui/material";
import React from "react";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

function DividerHome() {
  return (
    <>
      <Divider
        sx={{
          height: "3px",
          background: PureLightThemeCaaS.colors.alpha.orange[100],
          width: "80%",
          m: "auto ",
          mt: 5,
          mb: 5,
        }}
      />
    </>
  );
}

export default DividerHome;
